module.exports = require('./$.global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// ./~/vue2-google-maps/~/core-js/library/modules/$.html.js
// module id = 477
// module chunks = 0